import { Groups } from '../../api'
import { isValidGroup } from '@/utils/groupContext'

const initialState = () => {
    return {
        groupsList: [],
        projectEui: null,
        requestId: 0,
        contextVersion: 0,
    }
}

export const groups = {
    namespaced: true,
    state: initialState(),
    getters: {
        get_groups(state, getters, rootState) {
            return state.projectEui === rootState.project.nameEui ? state.groupsList : []
        }
    },
    actions: {
        async fetchGroups({ commit, state, rootState }) {
            const projectEui = rootState.project.nameEui
            if (!projectEui) return
            commit('START_REQUEST')
            const requestId = state.requestId
            const isCurrent = () => projectEui === rootState.project.nameEui && requestId === state.requestId
            try {
                const response = await Groups.getGroups()
                if (isCurrent()) commit('SET_GROUPS', { groups: response.data, projectEui })
            } catch (error) {
                if (!isCurrent()) return
                throw { type: 'group', error }
            }
        },
        async addGroup({ commit, rootState, state }, data) {
            const project = rootState.project.nameEui
            const contextVersion = state.contextVersion
            try {
                const response = await Groups.createGroup(data)
                if (project !== rootState.project.nameEui || contextVersion !== state.contextVersion) return false
                commit('ADD_GROUP', response.data)
                return true
            } catch {
                return false
            }
        },
        async editGroup({ dispatch, rootState, state }, data) {
            const project = rootState.project.nameEui
            const contextVersion = state.contextVersion
            const { id, ...rest } = data
            try {
                await Groups.updateGroup(rest, id)
                if (project !== rootState.project.nameEui || contextVersion !== state.contextVersion) return false
                await dispatch('fetchGroups')
                return true
            } catch {
                return false
            }
        },
        async deleteGroup({ commit, rootState, state }, data) {
            const project = rootState.project.nameEui
            const contextVersion = state.contextVersion
            const { _id } = data
            try {
                await Groups.deleteGroup(_id)
                if (project !== rootState.project.nameEui || contextVersion !== state.contextVersion) return false
                commit('DELETE_GROUP', _id)
                return true
            } catch {
                return false
            }
        },
    },
    mutations: {
        START_REQUEST(state) {
            state.requestId += 1
        },
        SET_GROUPS(state, { groups, projectEui }) {
            state.groupsList = Array.isArray(groups) ? groups.filter(isValidGroup) : []
            state.projectEui = projectEui
        },
        ADD_GROUP(state, groupToAdd) {
            state.groupsList.push(groupToAdd)
        },
        DELETE_GROUP(state, groupID) {
            state.groupsList = state.groupsList.filter(group => group._id !== groupID)
        },
        RESET(state) {
            Object.assign(state, initialState(), { requestId: state.requestId + 1, contextVersion: state.contextVersion + 1 })
        }
    }
}
